import React from 'react';
import type { ToolbarProps } from 'react-big-calendar';
import { Button } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';

// react-big-calendar's `components.toolbar` expects a ComponentType<ToolbarProps<TEvent, TResource>>.
// Using a generic function component (instead of React.FC) avoids incompatibilities with newer @types/react.
function Toolbar<TEvent extends object = object, TResource extends object = object>({
  label,
  onNavigate
}: ToolbarProps<TEvent, TResource>) {
  return (
    <div className="rbc-toolbar p-lg-0 mb-lg-3 mb-0 flex-row p-3">
      <Button onClick={() => onNavigate('PREV')}>
        <FaChevronLeft />
      </Button>
      <span className="rbc-toolbar-label fs-4 fw-normal text-uppercase text-info">{label}</span>
      <Button onClick={() => onNavigate('NEXT')}>
        <FaChevronRight />
      </Button>
    </div>
  );
}

export default Toolbar;
